import { PrivateProfileApi } from '../../generated/api';
import configuration from './configuration';

export default new PrivateProfileApi(configuration);
